import { ArrowUp, ArrowDown, Trash2, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const TYPES = [["text", "Text"], ["number", "Number"], ["date", "Date"], ["select", "Dropdown"], ["textarea", "Long text"]];
const sel = "h-9 rounded-md border border-slate-300 bg-white text-sm px-2";

export const FieldEditor = ({ fields, onChange }) => {
  const set = (i, patch) => onChange(fields.map((f, j) => (j === i ? { ...f, ...patch } : f)));
  const move = (i, d) => { const n = [...fields]; [n[i], n[i + d]] = [n[i + d], n[i]]; onChange(n); };
  return (
    <div className="space-y-2" data-testid="field-editor">
      {fields.map((f, i) => (
        <div key={i} className="rounded-lg border border-slate-200 bg-white p-3 flex flex-wrap items-center gap-2 fade-up" data-testid={`field-row-${i}`}>
          <span className="w-6 text-xs font-mono text-slate-400">{i + 1}</span>
          <Input value={f.label} onChange={(e) => set(i, { label: e.target.value })} placeholder="Field label" className="flex-1 min-w-[160px] bg-white" data-testid={`field-label-${i}`} />
          <select className={sel} value={f.type} onChange={(e) => set(i, { type: e.target.value })} data-testid={`field-type-${i}`}>
            {TYPES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
          <label className="flex items-center gap-1.5 text-xs text-slate-600">
            <input type="checkbox" checked={!!f.required} onChange={(e) => set(i, { required: e.target.checked })} data-testid={`field-required-${i}`} />Required
          </label>
          <div className="flex gap-1 ml-auto">
            <Button size="icon" variant="ghost" disabled={i === 0} onClick={() => move(i, -1)} data-testid={`field-up-${i}`}><ArrowUp className="w-4 h-4" /></Button>
            <Button size="icon" variant="ghost" disabled={i === fields.length - 1} onClick={() => move(i, 1)} data-testid={`field-down-${i}`}><ArrowDown className="w-4 h-4" /></Button>
            <Button size="icon" variant="ghost" onClick={() => onChange(fields.filter((_, j) => j !== i))} data-testid={`field-remove-${i}`}><Trash2 className="w-4 h-4 text-rose-600" /></Button>
          </div>
          {f.type === "select" && (
            <Input value={(f.options || []).join(", ")} onChange={(e) => set(i, { options: e.target.value.split(",").map((s) => s.trimStart()) })}
              placeholder="Choices, separated by commas" className="basis-full bg-white text-sm" data-testid={`field-options-${i}`} />
          )}
        </div>
      ))}
      <Button variant="outline" onClick={() => onChange([...fields, { label: "", type: "text", required: false, options: [] }])} data-testid="field-add-button">
        <Plus className="w-4 h-4 mr-1" />Add field
      </Button>
    </div>
  );
};

export const cleanFieldsForSave = (fields) =>
  fields.filter((f) => f.label.trim()).map((f) => ({ ...f, options: (f.options || []).map((o) => o.trim()).filter(Boolean) }));
